import React from 'react'
import { useSelector } from 'react-redux'
import CommentIcon from '../../../../../components/commentSection/commentIcon/CommentIcon.component'
import { getObstetricsSelector } from '../selectors'
import { ObstetricsConstants } from '../store/obstetrics.constants'
import { useTranslation } from 'react-i18next'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'

export const ObstetricsComment = () => {
  const obstetrics = useSelector(getObstetricsSelector)
  const { t } = useTranslation()
  const { comments, isPatientPregnantPNNV } = obstetrics

  const hasPNValues = isPatientPregnantPNNV && [8801019, 8801023].includes(isPatientPregnantPNNV.id)

  return (
    <CommentIcon
      className='comments'
      commentPageTitle={t('additionalAssessments.obstetrics.comments')}
      commentText={comments}
      commentMaxLength={4000}
      previousPagePath={TabConstants.BODY_ASSESSMENT}
      onChangeAction={[ObstetricsConstants.SET_COMMENTS, 'comments']}
      saveAction={[ObstetricsConstants.SAVE_OBSTETRICS]}
      enableClick={!hasPNValues}
      iconColor={hasPNValues ? 'neutral-base' : 'zoll-darkBlue'}
      validationAction={ObstetricsConstants.SET_COMMENTS}
    />
  )
}
